// extracted by mini-css-extract-plugin
export default {"container":"_3tub","header":"z0og","row":"_2pb5","final_amount":"_2DSy","totals_container":"_1VkR","payment_container":"_3lyd","payment_title":"_9o-v","payment_error":"_12Pt"};